module.exports = __webpack_public_path__ + "img/Task book swahili.bb125220.png";